module.exports = __webpack_public_path__ + "img/6e4d079337c8fbe7cff3ba9cfab79a12.png";